/* eslint-disable no-console */
import React, { Component } from 'react';
import { node } from 'prop-types';
import * as Sentry from '@sentry/browser';
import config from '../../config';
import css from './FieldWysiwyg.module.css';

class FieldWysiwygErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (config.sentryDsn) {
      Sentry.captureException(error, {
        tags: {
          code: 'field-wysiwyg-error-boundary',
          type: 'field_wysiwyg_error_boundary',
        },
        extra: errorInfo?.componentStack ? { componentStack: errorInfo.componentStack } : {},
      });
    }

    console.error('FieldWysiwyg error:', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className={css.errorFallback}>
          <p className={css.errorFallbackMessage}>
            The text editor ran into a problem. Your other form fields are still saved — reload the
            page to try again, or continue editing the rest of the package.
          </p>
          <button
            type="button"
            className={css.errorFallbackButton}
            onClick={() => this.setState({ hasError: false })}
          >
            Try editor again
          </button>
        </div>
      );
    }

    return children;
  }
}

FieldWysiwygErrorBoundary.propTypes = {
  children: node.isRequired,
};

export default FieldWysiwygErrorBoundary;
